// extracted by mini-css-extract-plugin
module.exports = {"root":"context-menu_root__kgXcl","dropdown-menu-left":"context-menu_dropdown-menu-left__w4Aru","dropdown-menu-right":"context-menu_dropdown-menu-right__aoWL4"};